import { render, staticRenderFns } from "./vuetiform-duration.vue?vue&type=template&id=abeceda6&scoped=true&"
import script from "./vuetiform-duration.vue?vue&type=script&lang=js&"
export * from "./vuetiform-duration.vue?vue&type=script&lang=js&"
import style0 from "./vuetiform-duration.vue?vue&type=style&index=0&id=abeceda6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abeceda6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSelect,VTextField})
